import { CoreMenu } from "@core/types";

export const menu: CoreMenu[] = [
  // {
  //   id: 'gam',
  //   title: '57th GAM',
  //   translate: 'MENU.GAM',
  //   type: 'item',
  //   icon: 'users',
  //   isFeatherIcon: true,
  //   url: 'gam',
  //   role: ['Basic']
  // },
  {
    id: "home",
    title: "Home",
    translate: "MENU.HOME",
    type: "item",
    icon: "home",
    isFeatherIcon: true,
    url: "home",
    role: ["Basic"],
  },
  {
    id: "shareCapital",
    title: "Share Capital",
    translate: "MENU.SHARE_CAPITAL",
    type: "item",
    icon: "dollar-sign",
    isFeatherIcon: true,
    url: "share-capital",
    role: ["Basic"],
  },
  {
    id: "e-fund",
    title: "EFund",
    translate: "MENU.EFUND",
    type: "item",
    icon: "e_wallet",
    isFeatherIcon: false,
    url: "e-fund",
    role: ["Basic"],
  },
  {
    id: 'investmentsAll',
    title: 'Investments',
    translate: 'MENU.INVESTMENTS',
    type: 'collapsible',
    icon: 'trending-up',
    isFeatherIcon: true,
    role: ['Basic'],
    children: [
      {
        id: "investments",
        title: "Investments",
        type: "item",
        url: 'investments'
      },
      {
        id: "investmentApplicationForms",
        title: "Application Forms",
        type: "item",
        url: 'investment-application-forms'
      },
    ]
  },
  {
    id: "accountManagement",
    title: "Account Mgmt.",
    translate: "MENU.SETUP",
    type: "collapsible",
    icon: 'book-open',
    isFeatherIcon: true,
    role: ["Basic"],
    children: [
      {
        id: "accountsReceivable",
        title: "Accounts Receivable",
        type: "item",
        url: "accounts-receivable",
      },
      // {
      //   id: "accountReceivable",
      //   title: "Accounts Receivable",
      //   type: "collapsible",
      //   children: [
      //     {
      //       id: "ar-Mdse",
      //       title: "AR-Mdse",
      //       type: "item",
      //       url: "accountmanagement/accountreceivable/ar-merchandise",
      //     },
      //     {
      //       id: "ar-Hogs",
      //       title: "AR-Hogs",
      //       type: "item",
      //       url: "accountmanagement/accountreceivable/ar-hogs",
      //     },
      //     {
      //       id: "ar-Aqua",
      //       title: "AR-Aqua",
      //       type: "item",
      //       url: "accountmanagement/accountreceivable/ar-aqua",
      //     },
      //     {
      //       id: "ar-SmatV",
      //       title: "AR-SmatV",
      //       type: "item",
      //       url: "accountmanagement/accountreceivable/ar-smatv",
      //     },
      //     {
      //       id: "ar-Fiber",
      //       title: "AR-Fiber",
      //       type: "item",
      //       url: "accountmanagement/accountreceivable/ar-fiber",
      //     },
      //   ],
        
      // },
      {
        id: "loansReceivable",
        title: "Loans Receivable",
        type: "item",
        url: "accountmanagement/loanreceivable",
      },
    ],
  },  
  {
    id: 'purchases',
    title: 'Purchases',
    translate: 'MENU.PURCHASES',
    type: 'item',
    icon: 'shopping-bag',
    isFeatherIcon: true,
    url: 'purchases',
    role: ['Basic']
  },
  // {
  //   id: 'transactions',
  //   title: 'Transactions',
  //   translate: 'MENU.MEMBER_TRANSACTIONS',
  //   type: 'item',
  //   icon: 'shopping-bag',
  //   url: 'transactions',
  //   role: ['Basic']
  // },
  // {
  //   id: 'loans',
  //   title: 'Loans',
  //   translate: 'MENU.LOANS',
  //   type: 'item',
  //   icon: 'credit-card',
  //   url: 'loans',
  //   role: ['Basic']
  // },

  {
    id: 'updateRequest',
    title: 'Update Request',
    translate: 'MENU.CHANGE_REQUEST',
    type: 'item',
    icon: 'edit',
    isFeatherIcon: true,
    url: 'applicant-update-request',
    role: ['Basic']
  },
  {
    id: 'digitalId',
    title: 'Digital ID',
    translate: 'MENU.DIGITAL_ID',
    type: 'item',
    icon: 'smartphone',
    isFeatherIcon: true,
    url: 'digital-id',
    role: ['Basic']
  },
  {
    id: 'annualReport',
    title: 'Annual Report',
    translate: 'MENU.MEMBERS_REPORT',
    type: 'item',
    icon: 'layers',
    isFeatherIcon: true,
    url: 'annual-report',
    role: ['Basic']
  },
  {
    id: 'membersReport',
    title: 'Reports',
    translate: 'MENU.MEMBERS_REPORT',
    type: 'item',
    icon: 'book',
    isFeatherIcon: true,
    url: 'reports',
    role: ['Basic']
  },
  // {
  //   id: 'productsAndServices',
  //   title: 'Products & Services',
  //   translate: 'MENU.PRODUCTS_AND_SERVICES',
  //   type: 'item',
  //   icon: 'map',
  //   isFeatherIcon: true,
  //   url: 'products-and-services',
  //   role: ['Basic']
  // },
  // {
  //   id: 'branches',
  //   title: 'Branches',
  //   translate: 'MENU.BRANCHES',
  //   type: 'item',
  //   icon: 'map-pin',
  //   isFeatherIcon: true,
  //   url: 'list-of-branches',
  //   role: ['Basic']
  // },
  {
    id: "contactUs",
    title: "Contact Us",
    translate: "MENU.CONTACT_US",
    type: "item",
    icon: "phone",
    isFeatherIcon: true,
    url: "contact-us",
    role: ["Basic"],
  },
  {
    id: "dashboard",
    title: "Dashboard",
    translate: "MENU.DASHBOARD",
    type: "item",
    icon: "home",
    isFeatherIcon: true,
    url: "admin/dashboard",
    role: ["SuperAdmin", "Admin", "BranchAdmin", "OutletAdmin","BillingAndCollection", "MerchandiseAndTrading", "Atikha"],
  },
  {
    id: "applicants",
    title: "Applicants",
    translate: "MENU.APPLICANTS",
    type: "item",
    icon: "user-plus",
    isFeatherIcon: true,
    url: "admin/applicants",
    role: ["SuperAdmin", "Admin", "BranchAdmin", "OutletAdmin", "Finance", "MerchandiseAndTrading"],
  },
  {
    id: "members",
    title: "Members",
    translate: "MENU.MEMBERS",
    type: "item",
    icon: "user-check",
    isFeatherIcon: true,
    url: "admin/members",
    role: ["SuperAdmin", "Admin", "BranchAdmin", "OutletAdmin", "MerchandiseAndTrading", "Finance", "Audit"],
  },
  {
    id: "atikha",
    title: "Atikha",
    translate: "MENU.ATIKHA",
    type: "item",
    icon: "community",
    isFeatherIcon: false,
    url: "admin/atikha",
    role: ["SuperAdmin","Atikha"],
  },
  {
    id: "leads",
    title: "Leads",
    translate: "MENU.LEADS",
    type: "item",
    icon: "zoom-in",
    isFeatherIcon: true,
    url: "admin/leads",
    role: ["SuperAdmin", "Admin", "BranchAdmin"],
  },
  {
    id: "young-cooperators",
    title: "Young Cooperators",
    translate: "MENU.YOUNG_COOPERATORS",
    type: "item",
    icon: "young_coop",
    isFeatherIcon: false,
    url: "admin/young-cooperators",
    role: ["SuperAdmin", "Admin", "BranchAdmin"],
  },
  {
    id: "manual-encoding",
    title: "Manual Encoding",
    translate: "MENU.MANUAL_ENCODING",
    type: "item",
    icon: "edit-3",
    isFeatherIcon: true,
    url: "admin/manual-encoding",
    role: ["SuperAdmin", "Admin"],
  },
  {
    id: "verify-requirements",
    title: "Verify Requirements",
    translate: "MENU.VERIFY_REQUIREMENTS",
    type: "item",
    icon: "check-circle",
    isFeatherIcon: true,
    url: "admin/verify-requirements",
    role: ["SuperAdmin", "Admin"],
  },
  {
    id: "events",
    title: "Seminars",
    translate: "MENU.EVENTS",
    type: "item",
    icon: "calendar",
    isFeatherIcon: true,
    url: "admin/events",
    role: ["SuperAdmin", "Admin", "BranchAdmin"],
  },
  {
    id: "pmes-attendance",
    title: "PMES Attendance",
    translate: "MENU.PMES_ATTENDANCE",
    type: "item",
    icon: "pmes_attendance",
    isFeatherIcon: false,
    url: "admin/pmes-attendance",
    role: ["SuperAdmin", "Admin"],
  },
  {
    id: "member-purchases",
    title: "Member Purchases",
    translate: "MENU.MEMBER_PURCHASES",
    type: "item",
    icon: "shopping-bag",
    isFeatherIcon: true,
    url: "admin/member-purchases",
    role: ["SuperAdmin"]
  },
  {
    id: "vouchers",
    title: "Vouchers",
    translate: "MENU.VOUCHERS",
    type: "item",
    icon: "gift",
    isFeatherIcon: true,
    url: "admin/vouchers",
    role: ["SuperAdmin", "Admin"],
  },
  {
    id: "admin-efund",
    title: "EFund",
    translate: "MENU.EFUND",
    type: "item",
    icon: "e_wallet",
    isFeatherIcon: false,
    url: "admin/e-fund",
    role: ['SuperAdmin','Admin','BranchAdmin','OutletAdmin','Accounting','BillingAndCollection','MerchandiseAndTrading','Finance'],
  },
  {
    id: "adminUpdateRequest",
    title: "Update Request",
    translate: 'MENU.CHANGE_REQUEST',
    type: "item",
    icon: 'edit',
    isFeatherIcon: true,
    url: "admin/adminchangerequest",
    role: ["SuperAdmin", "Admin"],
  },
  // {
  //   id: "adminGamPreReg",
  //   title: "GAM Pre-Reg",
  //   translate: 'MENU.GAM_PREREG_ADMIN',
  //   type: "item",
  //   icon: 'users',
  //   isFeatherIcon: true,
  //   url: "admin/gam-pre-reg",
  //   role: ["SuperAdmin", "Admin", "BranchAdmin"],
  // },
  {
    id: "announcements",
    title: "Announcements",
    translate: "MENU.ANNOUNCEMENTS",
    type: "item",
    icon: "bell",
    isFeatherIcon: true,
    url: "admin/announcements",
    role: ["SuperAdmin", "Marketing"],
  },
  {
    id: "financials",
    title: "Financials",
    translate: "MENU.FINANCIALS",
    type: "collapsible",
    icon: "layers",
    isFeatherIcon: true,
    role: ["SuperAdmin", "BillingAndCollection"],
    children: [
      {
        id: "accountsReceivableAdmin",
        title: "Accounts Receivable",
        type: "item",
        url: "admin/financials/accounts-receivable",
      },
      // {
      //   id: "accountReceivable",
      //   title: "Accounts Receivable",
      //   type: "collapsible",
      //   children: [
      //     {
      //       id: "accountReceivableMerchandise",
      //       title: "AR-Merchandise",
      //       type: "item",
      //       url: "admin/financials/ar-merchandise",
      //     },
      //     {
      //       id: "accountReceivableHogs",
      //       title: "AR-Hogs",
      //       type: "item",
      //       url: "admin/financials/ar-hogs",
      //     },
      //     {
      //       id: "accountReceivableAqua",
      //       title: "AR-Aqua",
      //       type: "item",
      //       url: "admin/financials/ar-aqua",
      //     },
      //     {
      //       id: "accountReceivableSmatV",
      //       title: "AR-SmatV",
      //       type: "item",
      //       url: "admin/financials/ar-smatv",
      //     },
      //     {
      //       id: "accountReceivableFiber",
      //       title: "AR-Fiber",
      //       type: "item",
      //       url: "admin/financials/ar-fiber",
      //     },
      //   ]
        
      // },
      {
        id: "loansReceivable",
        title: "Loans Receivable",
        type: "item",
        url: "admin/financials/loans-receivable",
      },
      {
        id: "investment",
        title: "Investment",
        type: "collapsible",        
        children: [
          {
            id: "investment",
            title: "Investment",
            type: "item",
            url: "admin/financials/investment"            
          },
          {
          id: "investmentApplication",
          title: "Application Forms",
          type: "item",
          url: "admin/financials/investment-application-forms"
        }
      ]
      },
    ],
  },
  {
    id: "dividend",
    title: "Dividend",
    translate: "MENU.DIVIDEND",
    type: "item",
    icon: "grid",
    isFeatherIcon: true,
    url: "admin/dividend",
    role: ["SuperAdmin"],
  },
  {
    id: "reports",
    title: "Reports",
    translate: "MENU.REPORTS",
    type: "item",
    icon: "book",
    isFeatherIcon: true,
    url: "admin/reports",
    role: ["SuperAdmin", "Admin", "BranchAdmin", "Finance"],
  },
  {
    id: "users",
    title: "Users",
    translate: "MENU.USERS",
    type: "item",
    icon: "users",
    isFeatherIcon: true,
    url: "admin/users",
    role: ["SuperAdmin","Admin"],
  },
  {
    id: "setup",
    title: "Setup",
    translate: "MENU.SETUP",
    type: "collapsible",
    icon: "tool",
    isFeatherIcon: true,
    role: ["SuperAdmin","Admin","Accounting","BranchAdmin","OutletAdmin","BillingAndCollection","MerchandiseAndTrading","Finance"],
    children: [
      {
        id: "eFundBenefits",
        title: "EFund Benefits",
        type: "item",
        url: "admin/setup/efund-benefits",
      },
      {
        id: "eFundUserAccess",
        title: "EFund Access",
        type: "item",
        url: "admin/setup/efund-user-access",
      },
      {
        id: "membershipRequirements",
        title: "Requirements",
        type: "item",
        url: "admin/setup/membership-requirements",
      },
      {
        id: "regionMunicipalities",
        title: "Region",
        type: "item",
        url: "admin/setup/region-municipalities",
      },
    ],
  },
  {
    id: "superAdminSetup",
    title: "Super Admin Setup",
    translate: "MENU.SUPER_ADMIN_SETUP",
    type: "collapsible",
    icon: "settings",
    isFeatherIcon: true,
    role: ["SuperAdmin"],
    children: [
      {
        id: "evote",
        title: "Evote",
        type: "item",
        url: "admin/superadminsetup/evote-links",
      },
      {
        id: "application-config",
        title: "Application Config",
        type: "item",
        url: "admin/superadminsetup/application-config",
      },
      {
        id: "bod-signatory",
        title: "BOD Signatory",
        type: "item",
        url: "admin/superadminsetup/bod-signatory",
      },
      {
        id: "superadmin-gam",
        title: "GAM",
        type: "item",
        url: "admin/superadminsetup/gam",
      },     
    ],
  },
  // {
  //   id: 'settings',
  //   title: 'Settings',
  //   translate: 'MENU.SETTINGS',
  //   type: 'collapsible',
  //   role: ['Basic', 'Admin'],
  //   icon: 'settings',
  //   children: [
  //   ]
  // },
];
